export default __webpack_public_path__ + "static/media/Combat Rating Boost (4h).2be4f89e.jpg";